export default __webpack_public_path__ + "gb.svg?2e88cb99771aa57e79b30c69af0906ea";